import api from './api';

const bonsLivraisonApi = {
  getAll: (params) => api.get('/bons-livraison', { params }),
  sync:   ()       => api.post('/bons-livraison/sync'),
};

export default bonsLivraisonApi;
